// extracted by mini-css-extract-plugin
export default {"bonusInfo":"variable-module__bonusInfo__Dpueb","gratisSpins":"variable-module__gratisSpins__Kh1A7"};